// US state name data for lifted state overlay
// Simplified - only contains state names (SVG path data removed as no longer needed)

export interface StatePathData {
  name: string
}

// State name data keyed by state code
export const usStatePaths: Record<string, StatePathData> = {
  AK: { name: 'Alaska' },
  AL: { name: 'Alabama' },
  AR: { name: 'Arkansas' },
  AZ: { name: 'Arizona' },
  CA: { name: 'California' },
  CO: { name: 'Colorado' },
  CT: { name: 'Connecticut' },
  DC: { name: 'District of Columbia' },
  DE: { name: 'Delaware' },
  FL: { name: 'Florida' },
  GA: { name: 'Georgia' },
  HI: { name: 'Hawaii' },
  IA: { name: 'Iowa' },
  ID: { name: 'Idaho' },
  IL: { name: 'Illinois' },
  IN: { name: 'Indiana' },
  KS: { name: 'Kansas' },
  KY: { name: 'Kentucky' },
  LA: { name: 'Louisiana' },
  MA: { name: 'Massachusetts' },
  MD: { name: 'Maryland' },
  ME: { name: 'Maine' },
  MI: { name: 'Michigan' },
  MN: { name: 'Minnesota' },
  MO: { name: 'Missouri' },
  MS: { name: 'Mississippi' },
  MT: { name: 'Montana' },
  NC: { name: 'North Carolina' },
  ND: { name: 'North Dakota' },
  NE: { name: 'Nebraska' },
  NH: { name: 'New Hampshire' },
  NJ: { name: 'New Jersey' },
  NM: { name: 'New Mexico' },
  NV: { name: 'Nevada' },
  NY: { name: 'New York' },
  OH: { name: 'Ohio' },
  OK: { name: 'Oklahoma' },
  OR: { name: 'Oregon' },
  PA: { name: 'Pennsylvania' },
  RI: { name: 'Rhode Island' },
  SC: { name: 'South Carolina' },
  SD: { name: 'South Dakota' },
  TN: { name: 'Tennessee' },
  TX: { name: 'Texas' },
  UT: { name: 'Utah' },
  VA: { name: 'Virginia' },
  VT: { name: 'Vermont' },
  WA: { name: 'Washington' },
  WI: { name: 'Wisconsin' },
  WV: { name: 'West Virginia' },
  WY: { name: 'Wyoming' },
}
